import { applyMiddleware, createStore, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';

import { getConsentCookie } from 'utils/cookieConsent';

import rootReducer from './reducers';
import saga from './sagas';
import loggerMiddleware from './middleware/logger';
import monitorReducerEnhancer from './enhancers/monitorReducer';

// eslint-disable-next-line import/no-mutable-exports
export let store;

const configureStore = () => {
    if (store) return store;

    const sagaMiddleware = createSagaMiddleware({
        onError: (error, stack) => {
            error.stack2 = stack.sagaStack; // eslint-disable-line no-param-reassign

            store.dispatch({ type: 'UNCAUGHT_EXCEPTION', payload: { error } });

            // using timeout to break out of redux-saga error handling
            setTimeout(() => {
                throw error;
            });
        },
    });

    const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

    const middlewareEnhancer = applyMiddleware(thunk, loggerMiddleware, sagaMiddleware);
    const composedEnhancers = composeEnhancers(middlewareEnhancer, monitorReducerEnhancer);

    const initialState = { cookies: { consent: getConsentCookie() } };

    store = createStore(rootReducer, initialState, composedEnhancers);
    sagaMiddleware.run(saga);

    return store;
};

export default configureStore;
